import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import moment from 'moment-timezone'
import React from 'react'
import AnimatedTableChevron from 'src/components/AnimatedTableChevron/AnimatedTableChevron'
import LoadingBoxBottom from 'src/components/LoadingBoxBottom/LoadingBoxBottom'
import NoPeople from 'src/components/NoPeople/NoPeople'
import UserAvatar from 'src/components/UserAvatar/UserAvatar'
import { AvatarSizes } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { OrgInviteModel } from 'src/models/people.models'
import Lnk from 'src/navigation/Lnk'
import { peopleInvitedToOrgDetailUrl } from 'src/navigation/urls'
import { css } from 'styled-components'

interface PeopleInvitedToOrgListSmallProps {
  invites: OrgInviteModel[]
  loading?: boolean
  sortableProps: {
    setSort: (field: string) => void
    sortBy?: string
    sortDescending?: boolean
  }
}

const PeopleInvitedToOrgListSmall: React.FC<
  PeopleInvitedToOrgListSmallProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      css={css`
        width: 100%;
      `}
    >
      {props.invites.length > 0 &&
        props.invites.map((invite, i) => {
          const { firstName, lastName, email, verified, id } = invite.invitee

          return (
            <Lnk
              css={css`
                padding: 24px 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 60px;
                border-top: 1px solid ${styleConstants.colors.gray_light};
                background-color: ${styleConstants.colors.gray_lightest};

                &:last-child {
                  border-bottom: 1px solid transparent;

                  &:hover {
                    border-bottom: 1px solid ${themeConstants.colors.cta_dark};
                  }
                }
                &:hover {
                  background-color: rgba(${styleConstants.colors.blue}, 0.1);
                  border-top: 1px solid ${themeConstants.colors.cta_dark};

                  .animated-table-chevron {
                    transform: translateX(4px);
                  }
                  & + * {
                    border-top: 1px solid ${themeConstants.colors.cta_dark};
                  }
                }
                &:last-child {
                  border-bottom: 1px solid ${styleConstants.colors.gray_light};
                }
              `}
              key={i}
              to={peopleInvitedToOrgDetailUrl(id)}
              ariaLabelSource={'People Details'}
            >
              <div
                css={css`
                  display: flex;
                  min-width: 0;
                `}
              >
                <UserAvatar
                  css={css`
                    margin-right: 10px;
                  `}
                  user={invite.invitee}
                  size={AvatarSizes.Small}
                />
                <div
                  css={css`
                    margin-left: 10px;
                    display: flex;
                    flex-direction: column;
                    min-width: 0;
                  `}
                >
                  <span
                    css={css`
                      ${getFontCss(
                        14,
                        themeConstants.colors.font_primary,
                        styleConstants.fontFamilies.medium,
                      )}
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow: hidden;
                    `}
                  >
                    {firstName === undefined ? (
                      email
                    ) : (
                      <span>
                        {' '}
                        {firstName} {lastName}{' '}
                      </span>
                    )}
                  </span>
                  {verified ? (
                    <div
                      css={css`
                        ${getFontCss(
                          12,
                          themeConstants.colors.font_primary,
                          styleConstants.fontFamilies.regular,
                        )}
                      `}
                    >
                      {translate('Registered')}
                    </div>
                  ) : (
                    <div
                      css={css`
                        ${getFontCss(
                          12,
                          styleConstants.colors.gray_dark,
                          styleConstants.fontFamilies.regular,
                        )}
                      `}
                    >
                      {translate('Unregistered')}
                    </div>
                  )}
                </div>
              </div>
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  padding-left: 10px;
                `}
              >
                <span
                  css={css`
                    flex-direction: column;
                    display: flex;
                    min-width: 0;
                    ${getFontCss(
                      12,
                      themeConstants.colors.font_primary,
                      styleConstants.fontFamilies.regular,
                    )}
                  `}
                >
                  <span>{translate('Invited')}</span>
                  {moment(invite.createdAt).format('L')}
                </span>
                <AnimatedTableChevron
                  css={css`
                    transform-origin: top right;
                    transform: scale(0.7);
                  `}
                />
              </div>
            </Lnk>
          )
        })}
      {props.loading ? (
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            flex-grow: 2;
          `}
        >
          <LoadingBoxBottom />
        </div>
      ) : (
        <div
          css={css`
            display: flex;
            justify-content: center;
          `}
        >
          {props.invites.length === 0 && (
            <NoPeople
              titleText={translate('No one matched your search.')}
              topSubtitleText={
                <div
                  css={css`
                    flex-direction: column;
                  `}
                >
                  {translate('Check the keyword you typed for any errors.')}
                </div>
              }
            />
          )}
        </div>
      )}
    </div>
  )
}
export default PeopleInvitedToOrgListSmall
